import { apiRequest } from "../utils/api";

// Auth relies solely on the Authorization: Bearer <token> header
// injected automatically by apiRequest — no custom headers needed.
export const getMe = () => apiRequest("/users/me");
